import $ from 'jquery';
import { getState } from '~src/state';
import { getUser } from '~src/user';
import {
  aggiungiServizioBlock,
  cambiaServizioBlock,
  colSizes,
  disableLoaderInput,
  displayLoadingContainer,
  doesSelectedProjectRequireFuneral,
  enableLoaderInput,
  initNewServizioForm,
  scegliServizioBlock,
  showContainer,
  hideContainer,
  setServizio,
} from '~loader/loader-utils';
import {
  fetchEditorProjectTypes,
  fetchProjectFormats,
  fetchCards,
} from '~loader/loader-api';
import {
  templateAddFormats,
  templateAddProjects,
  templateAddHelp,
} from '~loader/loader-template';
import {
  readFormatoFromQueryString,
  readTipoFromQueryString,
  checkShouldCreateCanvas,
} from '~loader/loader-utils/query-string';
import { subscribeObservables } from '../observables/subscribe';
import { isLoggedUserGlobalEditor } from '~src/user';
import { initPlayYouTubeModal } from '~src/help';
import isMobile from 'is-mobile';
import { fetchProjectFormatsDefault } from '~src/sidebar/index';
import { RecentProjects } from '~src/components/Projects';
import ReactDOM from 'react-dom';
import React from 'react';
import {
  fetchFuneralServiceById,
  countFuneralServices,
} from '~graphql/controllers';
import { modifyState } from '../state';
import { createEditorCanvas } from '~loader/loader-event-handlers';
import { FEATURES, isFeatureEnabled } from '../features';

const DEFAULT_OPTIONS = {
  includeRecentProjects: true,
};
/**
 * Render Loader
 */
export const renderLoader = async (options = DEFAULT_OPTIONS) => {
  const { includeRecentProjects = true } = {
    ...DEFAULT_OPTIONS,
    ...options,
  };
  displayLoadingContainer('formats', 'regular', 6, false);
  await subscribeObservables();
  const { user } = await getUser();
  const isUserInDemo = user.org_pointer.tipo_istanza === 'demo';
  disableLoaderInput();

  $('#editor-main-menu').show();

  if (isUserInDemo) {
    showContainer('help');
    templateAddHelp();
    initPlayYouTubeModal();
  }

  hideContainer('info-mobile-device');
  if (isMobile() && isUserInDemo) {
    showContainer('info-mobile-device');
    return enableLoaderInput();
  }

  showContainer('projects');
  displayLoadingContainer('projects', 'regular', 12, false);

  const { projects } = await fetchEditorProjectTypes();
  Object.assign(window.editorLoader, { projects });

  const isSelectedProjectType = readTipoFromQueryString(projects);
  await templateAddProjects();
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  if (!includeRecentProjects) {
    hideContainer('projects-recent');
    const domContainer = document.querySelector('#editor-projects-recent');
    if (domContainer) {
      ReactDOM.unmountComponentAtNode(domContainer);
      domContainer.innerHTML = '';
    }
  } else if (!isGlobalEditor) {
    const domContainer = document.querySelector('#editor-projects-recent');
    if (domContainer) {
      $('#recent-projects-loader').hide();
      displayLoadingContainer('projects-recent', 'regular', 12, false);
      showContainer('projects-recent');
      ReactDOM.render(React.createElement(RecentProjects), domContainer);
    }
  } else {
    hideContainer('projects-recent');
  }

  showContainer('navigation-breadcrumbs');

  if (!isSelectedProjectType) {
    return enableLoaderInput();
  }

  const requiresFuneral = doesSelectedProjectRequireFuneral();
  window.editorLoader.requiresFuneral = requiresFuneral;
  /**
   * Se la tipologia di progetto e' collegata ad un servizio
   * Faccio selezionare quello
   */
  if (requiresFuneral) {
    const isDefunctCreationEnabled = await isFeatureEnabled(
      FEATURES.CREATE_DEFUNCT
    );
    displayLoadingContainer(
      'servizio',
      'regular',
      isDefunctCreationEnabled ? 2 : 1,
      false
    );
    showContainer('servizio');

    const idServizio = window.urlParams.get('servizio');

    let servizio;
    let isServizioSelected;
    const allowCreateCards = await isFeatureEnabled(FEATURES.CREATE_CARDS);

    if (allowCreateCards && idServizio) {
      isServizioSelected = true;
      const cards = await fetchCards();
      const selectedCard = cards.find((card) => {
        if (card.slug === decodeURIComponent(idServizio)) {
          return card;
        }
      });
      modifyState('card', selectedCard);
      setServizio(selectedCard, false);
    } else if (idServizio) {
      servizio = await fetchFuneralServiceById(idServizio);
      if (servizio) {
        isServizioSelected = true;
        setServizio(servizio, false);
      }
    }
    if (isServizioSelected) {
      const servizio = getState('selected.servizio');

      const blockServizio = `<div class="${colSizes['regular']} mt-4 block-with-image block-selected"
        data-servizio="true"
        data-toggle="modal"
        data-target="#modalEditorServizio">
        <div class="block-image lazy" data-bg="./assets/blocks/placeholders/servizio.png"></div>
        <div class="block-name h5">${servizio.cognome} ${servizio.nome}</div></div>`;

      $('#editor-servizio').empty();
      $('#editor-servizio').append(blockServizio);
      $('#editor-servizio').append(cambiaServizioBlock);
      if (isDefunctCreationEnabled) {
        $('#editor-servizio').append(aggiungiServizioBlock);
      }
      initNewServizioForm();
      enableLoaderInput();
      window.lazyLoadInstance.update();
    } else {
      const allowCreateCards = await isFeatureEnabled(FEATURES.CREATE_CARDS);
      // deve scegliere o creare un servizio
      const orgServicesCount = await countFuneralServices();

      $('#editor-servizio').empty();
      if (orgServicesCount > 0 || allowCreateCards) {
        $('#editor-servizio').append(scegliServizioBlock);
      }
      if (isDefunctCreationEnabled) {
        $('#editor-servizio').append(aggiungiServizioBlock);
      }
      hideContainer('formats');
      hideContainer('templates-categories');
      initNewServizioForm();
      enableLoaderInput();
      window.lazyLoadInstance.update();

      if (allowCreateCards) {
        $('#servizio-container-title .loader-container-title').text('Cards');
        $('#editor-servizio .block-name').text('');
        $('#servizio-container-title .loader-container-sub-title').text(
          'Scegli una card'
        );
      }

      return;
    }
  } else {
    enableLoaderInput();
    hideContainer('servizio');
  }

  /**
   * Formats
   */

  showContainer('formats');

  const formats = await fetchProjectFormats(
    getState('selected.tipo'),
    window.editorLoader.forceFetchFormats
  );

  window.editorLoader.forceFetchFormats = false;

  const projectType = getState('selected.tipo');
  const projectId = projectType.objectId;
  window.editorLoader.formats[projectId] = formats;

  /**
   * Se il template e' personalizato faccio vedere tutti i formati
   */
  if (!projectType.isGlobal) {
    const allDefaultFormats = await fetchProjectFormatsDefault();
    projectType.default_formats = allDefaultFormats.formats.items;
  }

  const defautlFormats = projectType.default_formats || [];

  if (!window.editorLoader.defaultFormats[projectId]) {
    window.editorLoader.defaultFormats[projectId] = {};
  }
  window.editorLoader.defaultFormats[projectId][
    window.editorLoader.newFormatOrientation
  ] = { formats: defautlFormats };

  readFormatoFromQueryString(formats);
  await templateAddFormats();

  if (checkShouldCreateCanvas()) {
    await createEditorCanvas();
    return;
  }
};
